module.exports = __webpack_public_path__ + "static/media/banner_news_drlicita.2dbf9131.png";